(function () {
  // QA: add ?cart_tier_preview=1 to any URL to show the message outside its schedule
  // for this browser session; ?cart_tier_preview=0 turns it off again.
  var PREVIEW_KEY = 'cartTierPreview';
  var previewMatch = window.location.search.match(/[?&]cart_tier_preview=([01])/);
  try {
    if (previewMatch) {
      previewMatch[1] === '1'
        ? sessionStorage.setItem(PREVIEW_KEY, '1')
        : sessionStorage.removeItem(PREVIEW_KEY);
    }
  } catch (e) {}

  function isPreview() {
    if (window.Shopify && window.Shopify.designMode) return true;
    try {
      return sessionStorage.getItem(PREVIEW_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  class CartTierMessage extends HTMLElement {
    connectedCallback() {
      this.render();
    }

    isScheduled() {
      var now = Date.now();
      var start = Date.parse(this.dataset.start);
      var end = Date.parse(this.dataset.end);
      if (!isNaN(start) && now < start) return false;
      if (!isNaN(end) && now >= end) return false;
      return true;
    }

    // Threshold is in the shop currency; convert it with the same rate Shopify
    // uses for the visitor's currency so it matches what the discount sees.
    getThreshold() {
      var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
      var threshold = parseInt(this.dataset.threshold, 10) || 0;
      return Math.round(threshold * (rate > 0 ? rate : 1));
    }

    formatMoney(cents) {
      var currency = this.dataset.currency;
      try {
        return new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: currency,
        }).format(cents / 100);
      } catch (e) {
        return currency + ' ' + (cents / 100).toFixed(2);
      }
    }

    render() {
      var threshold = this.getThreshold();
      if (!threshold || (!isPreview() && !this.isScheduled())) {
        this.hidden = true;
        return;
      }

      var remaining = threshold - (parseInt(this.dataset.subtotal, 10) || 0);
      var text = remaining > 0 ? this.dataset.belowText : this.dataset.unlockedText;
      if (!text) {
        this.hidden = true;
        return;
      }

      // Build with text nodes so merchant-entered copy is never parsed as HTML.
      this.textContent = '';
      text.split('[amount]').forEach(function (part, index) {
        if (index > 0) {
          var amount = document.createElement('strong');
          amount.textContent = this.formatMoney(remaining);
          this.appendChild(amount);
        }
        this.appendChild(document.createTextNode(part));
      }, this);

      this.classList.toggle('cart-tier-message--unlocked', remaining <= 0);
      this.hidden = false;
    }
  }

  if (!customElements.get('cart-tier-message')) {
    customElements.define('cart-tier-message', CartTierMessage);
  }
})();
